import axios from '@/api/config';

const student = {
    getStudentById (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudent/` + data, {});
    },
    getStudent (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudent`, { params: data });
    },
    getStudentDetail (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudentDetail`, { params: data });
    },
    getStudentList (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudentList`, { params: data });
    },
    getStudentTree (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudentTree`, { params: data });
    },
    getStudentGroup (data) {
        return axios.get(`${process.env.BASE_URL}/studentGroup/getStudentGroup`, { params: data });
    },
    pageList (data) {
        return axios.post(`${process.env.BASE_URL}/student/pageList`, data);
    },
    classInfoPageList (data) {
        return axios.post(`${process.env.BASE_URL}/student/classInfoPageList`, data);
    },
    classInfoList (data) {
        return axios.post(`${process.env.BASE_URL}/student/pageList`, data);
    },
    exercisePageList (data) {
        return axios.post(`${process.env.BASE_URL}/student/exercisePageList`, data);
    },
    pageListGroup (data) {
        return axios.post(`${process.env.BASE_URL}/studentGroup/pageList`, data);
    },

    getStudentGroupList (data) {
        return axios.get(`${process.env.BASE_URL}/studentGroup/getStudentGroupList`, { params: data });
    },
    deleteStudentGroup (data) {
        return axios.delete(`${process.env.BASE_URL}/studentGroup/deleteStudentGroup`, { data: data });
    },
    addStudentGroup (data) {
        return axios.post(`${process.env.BASE_URL}/studentGroup/addStudentGroup`, data);
    },
    resetStudentPassword (data) {
        return axios.post(`${process.env.BASE_URL}/student/resetStudentPassword`, data);
    },
    studentBehaviorProfile (data) {
        return axios.post(`${process.env.BASE_URL}/student/studentBehaviorProfile`, data);
    },
    getLearningProfile (data) {
        return axios.post(`${process.env.BASE_URL}/student/getLearningProfile`, data);
    },
    getLastTenTimesExerciseRecords (data) {
        return axios.post(`${process.env.BASE_URL}/student/getLastTenTimesExerciseRecords`, data);
    },
    addStudent (data) {
        return axios.post(`${process.env.BASE_URL}/student/addStudent`, data);
    },
    updateStudentGroup (data) {
        return axios.put(`${process.env.BASE_URL}/studentGroup/updateStudentGroup`, data);
    },
    updateStudent (data) {
        return axios.put(`${process.env.BASE_URL}/student/updateStudent`, data);
    },
    studentOnOrOff (data) {
        return axios.put(`${process.env.BASE_URL}/student/studentOnOrOff`, data);
    },
    exportExcel (data) {
        return axios.post(`${process.env.BASE_URL}/student/exportExcel`, data);
    },
    getStudentFromTypeList (data) {
        return axios.get(`${process.env.BASE_URL}/student/getStudentFromTypeList`, { params: data });
    },
    importData (data) {
        return axios.post(`${process.env.BASE_URL}/student/importData`, data);
    },
    // 获取评论列表
    getCommentList (data) {
        return axios.get(`${process.env.BASE_URL}/studentComments/queryByPage`, { params: data });
    },
    // 关闭评论状态
    changeCommentStatus (data) {
        return axios.post(`${process.env.BASE_URL}/studentComments/updateById`, data);
    },
}

export default student;



// WEBPACK FOOTER //
// ./src/api/student.js